import React from 'react'
import { LoginButton, Register as RegisterCore } from '@ztechapps/webui.auth'
import { useBasicRegister } from '@ztechapps/common.hook'
import { HorizontalStack } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'
import { appSettings } from '../../../config/app-settings'

export const RegisterForm = () => {
  const recaptchaSiteKey = appSettings?.Google?.recaptchaSiteKey

  const [onRegister] = useBasicRegister({ url: `/api/auth/basic/register` })
  const handleSubmit = async ({ fullName, ...rest }) => {
    const { error } = await onRegister({ ...rest, name: fullName })
    if (error) throw error
  }

  return (
    <Stack gap={2}>
      <Stack gap={4}>
        <div>
          <RegisterCore onSubmit={handleSubmit} recaptchaSiteKey={recaptchaSiteKey} />
        </div>

        <div>
          <HorizontalStack gap={4} className="justify-content-between align-items-md-center ">
            <div className="align-items-stretch flex-fill">
              <hr className="text-success border-4" />
            </div>
            <h4 className="fw-bold">OR</h4>
            <div className="align-items-stretch flex-fill">
              <hr className="text-success border-4" />
            </div>
          </HorizontalStack>
        </div>

        <div>
          <LoginButton uri={`/api/auth/google`} text="Register with Google" />
        </div>
      </Stack>
    </Stack>
  )
}
